/**
 * CreativeProvesSummary — short synthesis paragraph rendered at the bottom
 * of the Persona Fit tab. Synthesizes the persona's response from
 * top_strength + critical_gap + scenario_alignment fields. Phase 2: derived
 * client-side; later phases may use a server-pre-generated paragraph.
 */

interface Props {
  latestReview: Record<string, unknown> | null;
  creativeHeadline?: string;
  personaId: string | null;
}

export function CreativeProvesSummary({ latestReview, personaId }: Props) {
  if (!latestReview) return null;

  const personaAnalysis = (latestReview.persona_analysis as Record<string, unknown> | null) ?? {};
  const topStrength = (latestReview.top_strength as string) ?? '';
  const criticalGap = (latestReview.critical_gap as string) ?? '';
  const scenarioAlignment = (personaAnalysis?.scenario_alignment as string) ?? '';

  if (!topStrength && !scenarioAlignment) return null;

  const personaLabel = personaId ?? 'this persona';

  const parts: string[] = [];
  parts.push(
    `This creative confirms that ${personaLabel} responds to ${
      topStrength.length > 0 ? topStrength.toLowerCase() : 'the primary message'
    }.`,
  );
  if (scenarioAlignment) parts.push(`Scenario alignment: ${scenarioAlignment.toLowerCase()}.`);
  if (criticalGap) parts.push(`Opportunity: ${criticalGap.toLowerCase()}.`);

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 space-y-1.5">
      <p className="text-[10px] font-mono uppercase tracking-wider text-slate-400">
        What This Creative Proves
      </p>
      <p className="text-sm text-slate-700 leading-relaxed">{parts.join(' ')}</p>
    </div>
  );
}
